module.exports = __webpack_public_path__ + "img/hazardEquip10.02b45681.png";